module.exports = __webpack_public_path__ + "static/media/18.ecff6fae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Carousel/CarouselMedia/18.jpg
// module id = 179
// module chunks = 0